// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { WeatherTypes } from "./Shared.WeatherTypes.gen";
import { TimeOfDay } from "./Shared.TimeOfDay.gen";
import { SceneType } from "./Shared.SceneType.gen";
import { TargetTypes } from "./Shared.TargetTypes.gen";
import { FHWAClasses } from "./Shared.FHWAClasses.gen";

/* eslint-disable @typescript-eslint/no-unused-vars */
import { IsOptional, MaxLength } from 'class-validator';

/* eslint-enable @typescript-eslint/no-unused-vars */ //JTH
export interface IPhotoMetaSummary {
	deviceName: string | undefined;

	organizationId: string | undefined;

	id: string | undefined;

	externalTargetId: string | undefined;

	deviceId: string | undefined;

	dateCreated: string | undefined;

	targetCaptureDate: string | undefined;

	weather: WeatherTypes | number ;

	timeOfDay: TimeOfDay;

	scene: SceneType;

	targetTypesInView: TargetTypes | number ;

	fhwaClassesInView: FHWAClasses;

	dewarpedImage: boolean;

	numLanes: number;

	needsReview: boolean;

	width: number | undefined;

	height: number | undefined;

	isPng: boolean;

	jpegQuality: number | undefined;

	addedToTrainingDataset: boolean;

	addedToTrainingDatasetAt: string | undefined;

	trainingDatasetName: string | undefined;

	$type?: string | undefined;
}
export class PhotoMetaSummary {
	constructor(data?: IPhotoMetaSummary) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.dateCreated) { this.dateCreated = new Date(data.dateCreated); }
		if (data.targetCaptureDate) { this.targetCaptureDate = new Date(data.targetCaptureDate); }
		if (data.addedToTrainingDatasetAt) { this.addedToTrainingDatasetAt = new Date(data.addedToTrainingDatasetAt); }
	}

	deviceName: string | undefined;

	organizationId: string | undefined;

	id: string | undefined;

	externalTargetId: string | undefined;

	deviceId: string | undefined;

	dateCreated: Date | undefined = new Date();

	targetCaptureDate: Date | undefined = new Date();

	weather: WeatherTypes | number  = 0;

	timeOfDay: TimeOfDay = 0;

	scene: SceneType = 0;

	targetTypesInView: TargetTypes | number  = 0;

	fhwaClassesInView: FHWAClasses = 0;

	dewarpedImage: boolean = false;

	numLanes: number = 0;

	needsReview: boolean = false;

	width: number | undefined;

	height: number | undefined;

	isPng: boolean = false;

	jpegQuality: number | undefined;

	addedToTrainingDataset: boolean = false;

	addedToTrainingDatasetAt: Date | undefined;

	@IsOptional()
	@MaxLength(100)
	trainingDatasetName: string | undefined;

	static $type: string = "CoreApi.Models.PhotoMetaSummary, ";
	$type?: string | undefined = PhotoMetaSummary.$type;
}

